import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=e5134b92&"
import script from "./ManageProduct.vue?vue&type=script&lang=js&"
export * from "./ManageProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports